const breakpoints = ['initial', 'xs', 'sm', 'md', 'lg', 'xl'];

export { breakpoints };
//# sourceMappingURL=Responsive.js.map
